export const DialogResult = {
	Confirm: 0,
	Cancel: 1,
};
